import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { pad, assign } from 'lodash';
import getSymbolFromCurrency from 'currency-symbol-map';

assign(numeral.localeData('en'), {
  abbreviations: {
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T',
  },
});

export function format(value, abbreviated, precision, symbol, suffix, withPlus) {
  if (Number.isNaN(value)) {
    return null;
  }
  let p = precision;
  if (p === null || typeof (p) === 'undefined') {
    p = 0;
  }
  let zeros = '';
  if (value !== 0) {
    if (p > 0) {
      zeros = `.${pad('0', p)}`;
    }
  }
  let v = numeral(value).format(`0,0${zeros}${abbreviated ? 'a' : ''}`);
  if (symbol) {
    if (v.indexOf('-') === 0) {
      v = v.replace('-', `-${symbol}`);
    } else {
      let plus = '';
      if (value > 0 && withPlus) {
        plus = '+';
      }
      v = `${plus}${symbol}${v}`;
    }
  }
  if (suffix) {
    v += ` ${suffix}`;
  }
  return v;
}
class MoneyDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  
  render() {
    const {
      abbreviated, precision, withPlus,
      className, currencyIsoCode, baseValue,
    } = this.props;
    let suffix = '';
    let symbol = '';
    let { value } = this.props;
    const organization = this.context.userCurrentOrganization;
    if (organization && organization.display_opportunity_base_currency === true && baseValue !== null && currencyIsoCode && currencyIsoCode !== organization.base_currency_iso_code) {
      symbol = getSymbolFromCurrency(currencyIsoCode);
      suffix = symbol === '$' ? currencyIsoCode : ''; // USD 123, CAD 456
      value = baseValue;
    } else if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    const v = format(value, abbreviated, precision, symbol, suffix, withPlus);
    return (
      <span className={`money-display ${className}`}>{v}</span>
    );
  }
}


MoneyDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  organization: PropTypes.shape({}),
  abbreviated: PropTypes.bool,
  precision: PropTypes.number,
  withPlus: PropTypes.bool,
  className: PropTypes.string,
  currencyIsoCode: PropTypes.string,
  baseValue: PropTypes.number,
};
MoneyDisplay.defaultProps = {
  value: null,
  abbreviated: false,
  organization: null,
  precision: 0,
  withPlus: false,
  className: null,
  baseValue: null,
  currencyIsoCode: null,
};

MoneyDisplay.contextTypes = {
  userCurrentOrganization: PropTypes.shape({}).isRequired,
}

export default MoneyDisplay;